import React, { useState } from "react";
import {
  SearchIcon,
  ChevronDown,
  CircleAlert,
  X,
  Settings as SettingsIcon,
  User,
  Building,
  CreditCard,
  UserCog,
  Truck,
  Shield,
  Bell,
  FileText,
  RefreshCw,
  RotateCw,
} from "lucide-react";
import { IconButton, Tabs, Tab, Box } from "@mui/material";
import ProductSection from "../ProductsModule/Components/ProductSection";

// Tab components imports
import GeneralSettings from "./Components/GeneralSettings";
import UserPermissions from "./Components/UserPermissions";
import NotificationSettings from "./Components/NotificationSettings";
import SecuritySettings from "./Components/SecuritySettings";
import BillingSettings from "./Components/BillingSettings";
import IntegrationSettings from "./Components/IntegrationSettings";
import TaxSettings from "./Components/TaxSettings";
import CompanySettings from "./Components/CompanySettings";

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1000);
  };

  return (
    <div className="bg-white">
      {/* Header Section */}
      <div className="flex items-center justify-between px-6 py-4 border-b">
        <h1 className="text-2xl font-semibold font-outfit text-gray-800">
          Settings
        </h1>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <IconButton
            onClick={handleRefresh}
            className="hover:bg-gray-100"
            disabled={isRefreshing}
            title="Refresh">
            <RotateCw
              size={20}
              className={`text-gray-600 ${isRefreshing ? "animate-spin" : ""}`}
            />
          </IconButton>
        </div>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#5652B0",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              color: "#4B5563",
              minWidth: "auto",
              padding: "12px 16px",
              fontFamily: "Outfit",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
            },
            "& .Mui-selected": {
              color: "#5652B0",
              fontWeight: 600,
            },
          }}>
          <Tab
            icon={<Building size={16} />}
            iconPosition="start"
            label="Company"
          />
          <Tab
            icon={<UserCog size={16} />}
            iconPosition="start"
            label="User Permissions"
          />
          <Tab
            icon={<Bell size={16} />}
            iconPosition="start"
            label="Notifications"
          />
          {/* <Tab
            icon={<Shield size={16} />}
            iconPosition="start"
            label="Security"
          /> */}
          {/* <Tab
            icon={<CreditCard size={16} />}
            iconPosition="start"
            label="Billing"
          /> */}
          {/* <Tab
            icon={<Truck size={16} />}
            iconPosition="start"
            label="Integrations"
          /> */}
          <Tab icon={<FileText size={16} />} iconPosition="start" label="Tax" />
        </Tabs>
      </Box>

      <div
        className="p-6 overflow-y-auto"
        style={{ maxHeight: "calc(100vh - 240px)" }}>
        {activeTab === 0 && <CompanySettings />}
        {activeTab === 1 && <UserPermissions />}
        {activeTab === 2 && <NotificationSettings />}
        {/* {activeTab === 3 && <SecuritySettings />}
        {activeTab === 4 && <BillingSettings />}
        {activeTab === 5 && <IntegrationSettings />} */}
        {activeTab === 3 && <TaxSettings />}
      </div>
    </div>
  );
};

export default Settings;
